import { useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";

const NAV_SECTIONS = [
    {
        id: "collapsemaster",
        label: "Master",
        icon: "fa-solid fa-user-gear",
        links: [
            { to: "/servicemanagement", label: "Service Management" },
            { to: "/procmanagement", label: "Processor Management" },
            { to: "/addReseller", label: "Reseller Management" },
        ],
    },
    {
        id: "collapseMeMgmt",
        label: "Merchant Management",
        icon: "fa-solid fa-store",
        links: [
            { to: "/pendingmerchantmanagement", label: "Pending" },
            { to: "/approvedmerchantmanagement", label: "Approved" },
        ],
    },
    {
        id: "collapsePayin",
        label: "Payin Section",
        icon: "fa-solid fa-circle-dollar-to-slot",
        links: [
            { to: "/dashboard", label: "Dashboard" },
            { to: "/payinWallet", label: "Wallet" },
            { to: "/payinWalletReport", label: "Wallet Report" },
            { to: "/transactions", label: "Transactions" },
        ],
    },
    {
        id: "collapsePayout",
        label: "Payout Section",
        icon: "fa-solid fa-money-bill-transfer",
        links: [
            { to: "/payoutDashboard", label: "Dashboard" },
            { to: "/payoutWallet", label: "Wallet" },
            { to: "/reversal", label: "Reversal" },
            { to: "/passbook", label: "Passbook" },
        ],
    },
];

export default function SidebarNavigation({ setAuth }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [openSection, setOpenSection] = useState(
        () => NAV_SECTIONS.find((section) => section.links.some((l) => l.to === location.pathname))?.id
            ?? NAV_SECTIONS[0].id
    );

    const Logout = () => {
        setAuth(false);
        navigate("/");
        sessionStorage.clear();
    };

    const toggleSection = (id) => {
        setOpenSection((prev) => (prev === id ? null : id));
    };

    const closeOnMobile = () => setMobileOpen(false);

    return (
        <>
            <button
                type="button"
                className="sidebar-burger"
                aria-label={mobileOpen ? "Close navigation menu" : "Open navigation menu"}
                aria-expanded={mobileOpen}
                onClick={() => setMobileOpen((prev) => !prev)}
            >
                <i className={`fa-solid ${mobileOpen ? "fa-xmark" : "fa-bars"}`}></i>
            </button>

            {mobileOpen && <div className="sidebar-backdrop" onClick={closeOnMobile}></div>}

            <nav className={`sidebarnavi ${mobileOpen ? "is-open" : ""}`} aria-label="Primary">
                <div className="sidebar-brand">
                    <img src={logo} alt="Company logo" />
                    <span className="sidebar-brand__tag">Admin Console</span>
                </div>

                <div className="sidebar-scroll">
                    <ul className="sidebar-nav" id="sidebarAccordion">
                        {NAV_SECTIONS.map((section) => {
                            const isOpen = openSection === section.id;
                            const hasActiveChild = section.links.some((l) => l.to === location.pathname);
                            return (
                                <li className="sidebar-group" key={section.id}>
                                    <button
                                        type="button"
                                        className={`sidebar-group__trigger ${hasActiveChild ? "is-current" : ""}`}
                                        aria-expanded={isOpen}
                                        aria-controls={section.id}
                                        onClick={() => toggleSection(section.id)}
                                    >
                                        <i className={section.icon}></i>
                                        <span>{section.label}</span>
                                        <i className={`fa-solid fa-chevron-down sidebar-group__chevron ${isOpen ? "is-open" : ""}`}></i>
                                    </button>
                                    <div className={`sidebar-group__panel ${isOpen ? "is-open" : ""}`} id={section.id}>
                                        {section.links.map((link) => (
                                            <NavLink
                                                key={link.to}
                                                to={link.to}
                                                onClick={closeOnMobile}
                                                className={({ isActive }) =>
                                                    `sidebar-link ${isActive ? "is-active" : ""}`
                                                }
                                            >
                                                <span className="sidebar-link__dot"></span>
                                                {link.label}
                                            </NavLink>
                                        ))}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>

                <button type="button" className="sidebar-logout" onClick={Logout}>
                    <i className="fa-solid fa-power-off"></i>
                    <span>Logout</span>
                </button>
            </nav>
        </>
    );
}
